import { message } from 'antd';
import { getSessionId } from '../NexaStore';
import { getCustomerInfo } from '@src/globalStore/profileStore';
import { buildMainHeader, downloadCsv } from '../../export/buildCsv';
import { logger } from '@src/utils/misc/logger';

/**
 * Utility function to convert HTML table data to CSV format
 * Handles proper escaping of quotes, commas, and newlines
 *
 * @param table - HTMLTableElement to convert
 * @returns CSV formatted string
 */
export const tableToCSV = (table: HTMLTableElement): string => {
  const rows = Array.from(table.querySelectorAll('tr'));
  return rows
    .map((row) => {
      const cells = Array.from(row.querySelectorAll('th, td'));
      return cells
        .map((cell) => {
          const text = cell.textContent || '';
          // Escape quotes and wrap in quotes if contains comma, quote, or newline
          if (text.includes(',') || text.includes('"') || text.includes('\n')) {
            return `"${text.replace(/"/g, '""')}"`;
          }
          return text;
        })
        .join(',');
    })
    .join('\n');
};

/**
 * Combined function to convert table to CSV and download it
 * Convenience function that handles the full export process
 *
 * @param table - HTMLTableElement to export
 * @param filename - Name of the file (default: 'table-data.csv')
 */
export const exportTableAsCSV = (table: HTMLTableElement): void => {
  try {
    const { customerName } = getCustomerInfo();
    const sessionId = getSessionId();
    const tableData = tableToCSV(table);

    // Build CSV with main header at the top
    const csvParts: string[] = [];
    csvParts.push(buildMainHeader(customerName));
    csvParts.push(tableData);

    const csvContent = csvParts.join('\r\n');
    downloadCsv(csvContent, `nexa_${sessionId}`);

    message.success('Table data downloaded as CSV');
  } catch (error) {
    message.error('Failed to export table data');
    logger.log('Error exporting table as CSV:', error);
  }
};
